// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

const sortFunction = (fields: string[], a: any, b: any): number => {
  const valueA = a[fields[0]];
  const valueB = b[fields[0]];
  return fields.length === 1
    ? valueA.localeCompare(valueB)
    : sortFunction(
        fields.filter((item, index) => index > 0),
        valueA,
        valueB
      );
};

export const AlphabeticalSorter = (field: string) => {
  const fields: string[] = field.split(".");
  return (a: any, b: any) => sortFunction(fields, a, b);
};

const sortWithFalsyFunction = (fields: string[], a: any, b: any): number => {
  const valueA = a[fields[0]];
  const valueB = b[fields[0]];
  return fields.length === 1
    ? valueA
      ? valueB
        ? valueA.localeCompare(valueB)
        : -1
      : valueB
      ? 1
      : 0
    : sortWithFalsyFunction(
        fields.filter((item, index) => index > 0),
        valueA,
        valueB
      );
};

export const AlphabeticalWithFalsySorter = (field: string) => {
  const fields: string[] = field.split(".");
  return (a: any, b: any) => sortWithFalsyFunction(fields, a, b);
};
